import React from "react";
import { MapPin, ArrowRight, BadgeCheck } from "lucide-react";
import { resolveImageUrl } from "@/lib/api";
import { useT } from "@/context/LangContext";

function formatEuro(n) {
  return Number.isInteger(n) ? `${n}` : n.toFixed(1).replace(".", ",");
}

export default function PartnerCard({ partner, onClick, index = 0 }) {
  const { t } = useT();
  const unitValue = partner.offer_value || 0;

  return (
    <article
      data-testid={`partner-card-${partner.id}`}
      onClick={onClick}
      className="card-premium cursor-pointer overflow-hidden group"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-muted">
        <img
          src={resolveImageUrl(partner.image_url)}
          alt={partner.name}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        />
        <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
          {(partner.badges || []).slice(0, 2).map((b) => (
            <span key={b} className="chip bg-white/90 text-navy-900 backdrop-blur-sm">
              {b}
            </span>
          ))}
        </div>
        {partner.featured && (
          <span className="absolute top-3 right-3 chip bg-lime-500 text-navy-900">
            <BadgeCheck className="w-3 h-3" /> {t("card.featured")}
          </span>
        )}
        {unitValue > 0 && (
          <div className="absolute bottom-3 right-3 bg-navy-900 text-white rounded-2xl px-3 py-2 shadow-lg">
            <div className="flex items-baseline gap-0.5">
              <span className="font-heading font-black text-2xl leading-none">-{formatEuro(unitValue)}</span>
              <span className="font-heading font-bold text-lime-400 text-lg">€</span>
            </div>
            <div className="text-[9px] uppercase tracking-widest text-white/60 mt-0.5 font-semibold">{t("card.economy")}</div>
          </div>
        )}
      </div>
      <div className="p-5">
        <h3 className="font-heading font-bold text-navy-900 text-lg">{partner.name}</h3>
        <div className="flex items-center gap-1 text-xs text-muted-foreground mt-1">
          <MapPin className="w-3 h-3" /> {partner.city}
        </div>
        <p className="text-sm text-navy-900 mt-3 font-semibold line-clamp-2 leading-snug">{partner.offer}</p>
        <div className="mt-4 pt-4 border-t border-navy-900/5 flex items-center justify-between">
          <span className="text-xs text-muted-foreground">
            {unitValue > 0 ? (
              <span className="text-navy-900 font-semibold">−{formatEuro(unitValue)}€ {t("card.per_use")}</span>
            ) : partner.category}
          </span>
          <span className="inline-flex items-center gap-1 text-sm font-semibold text-navy-900 group-hover:text-lime-600 transition">
            {t("card.see")} <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition" />
          </span>
        </div>
      </div>
    </article>
  );
}
